import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Lang from '~/lang'
import Echo from 'laravel-echo'
import VueLazyload from 'vue-lazyload'
import lookup from 'country-code-lookup'
// import { proxyTrack } from './proxy-track'

if (process.env.MIX_WEBSOCKET_CLIENT_DRIVER === 'pusher') {
    window.Pusher = require('pusher-js')
}

if (process.env.MIX_WEBSOCKET_CLIENT_DRIVER === 'socket.io') {
    window.io = require('socket.io-client')
}

let wsHost = process.env.MIX_WEBSOCKET_CLIENT_HOST
let wsPort = process.env.MIX_WEBSOCKET_CLIENT_PORT
let wssPort = wsPort
let host = process.env.MIX_WEBSOCKET_SERVER_LOCAL == 'true' ? `${wsHost}:${wsPort}` : null

// const pusherTracker = proxyTrack(Pusher)

/*if ((process.env.MIX_WEBSOCKET_CLIENT_DRIVER == 'pusher') && (process.env.MIX_WEBSOCKET_SERVER_LOCAL == 'false')) {
    window.laraSock = new Pusher(process.env.MIX_PUSHER_SYNC_APP_KEY, {
        host,
        wsHost,
        wsPort,
        wssPort,
        httpHost: host,
        authEndpoint: "/broadcasting/auth",
    })
}*/

const options = {
    broadcaster: process.env.MIX_WEBSOCKET_CLIENT_DRIVER,
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: process.env.MIX_WEBSOCKET_SERVER_ENCRYPTED,
    enabledTransports: ['ws', 'wss'],
    forceTLS: false,
}

if ((process.env.MIX_WEBSOCKET_SERVER_LOCAL == 'true') && host) {
    options.host = host
}

if ((process.env.MIX_WEBSOCKET_SERVER_LOCAL == 'true') && wsHost) {
    options.wsHost = wsHost
}

if ((process.env.MIX_WEBSOCKET_SERVER_LOCAL == 'true') && wsPort) {
    options.wsPort = wsPort
    options.wssPort = wssPort
}

window.Echo = new Echo(options)

Vue.config.productionTip = false

/**
 * Then you can do stuff like this:
 *
 * route('bids.store')
 */
// Vue.mixin({
//     methods: {
//         route: route,
//     },
// })

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec)
            return '' + Math.round(n * k) / k
        }
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
}

function toCurrency(value, currency) {
    const formated = number_format(
        value, currency.decimals,
        currency.decimal_point,
        currency.thousands_sep)

    return `${currency.prefix || ''} ${formated} ${currency.suffix || ''}`.trim()
}

/**
 * Then you can do stuff like this:
 *
 * {{ currentBid | currency('en-US', 'EUR') }}
 * {{ currentBid | currency('de-DE', 'EUR') }}
 */
Vue.filter('currency', toCurrency)

/**
 * Then you can do stuff like this:
 *
 * {{ 'javascript.title.home' | trans }}
 * {{ 'javascript.title.welcome' | trans({ name: 'Nasirou' }) }}
 */
Vue.filter('trans', (...args) => {
    return Lang.get(...args)
})

function shortcuteCountryName(name) {
    if (name.indexOf('(') >= 0) {
        return name.substring(0, name.indexOf('(')).trim()
    } else {
        return name
    }
}

window.shortcuteCountryName = shortcuteCountryName

/**
 * Then you can do stuff like this:
 *
 * {{ bid.country_name | shortcute }}
 */
Vue.filter('shortcute', shortcuteCountryName)

/**
 * Then you can do stuff like this:
 *
 * {{ date_of_birth | formatDateToEuropeDate(local) }}
 */
Vue.filter('formatDateToEuropeDate', (value, local) => {
    if (value) {
        return moment(String(value))
            .local(local)
            .format('DD.MM.YYYY')
    }
})

function countryCodeISO3(code) {
    return lookup.byIso(code.toUpperCase())
        ? lookup.byIso(code.toUpperCase()).iso3
        : code.toUpperCase()
}

/**
 * Then you can do stuff like this:
 *
 * {{ bid.country_code | countryCodeISO3 }}
 */
Vue.filter('countryCodeISO3', countryCodeISO3)

Vue.use(VueLazyload, {
    adapter: {
        loaded({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
            // do something here
            // example for call LoadedHandler
            el.classList.add('lazy-loaded')
        },
        loading(listender, Init) {
        },
        error(listender, Init) {
        },
    },
})

Vue.use(VueCookies)

window.numberToCurrency = toCurrency
